<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const open = ref(false)
const publicBase = import.meta.env.BASE_URL
const page = (path: string) => `${publicBase}${path}/`
const route = useRoute()
const isEn = computed(() => route.meta.locale === 'en')
const localePath = computed(() => `${publicBase}${String(route.meta.alternate ?? '/').replace(/^\//, '')}`)
const menuLabel = computed(() => {
  if (isEn.value) return open.value ? 'Close menu' : 'Open menu'
  return open.value ? 'Zamknij menu' : 'Otwórz menu'
})
const close = () => { open.value = false }
const onKeydown = (event: KeyboardEvent) => { if (event.key === 'Escape') close() }

watch(open, (isOpen) => {
  if (typeof document !== 'undefined') document.body.classList.toggle('menu-open', isOpen)
})
onMounted(() => window.addEventListener('keydown', onKeydown))

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown)
  document.body.classList.remove('menu-open')
})
</script>

<template>
  <header class="site-header">
    <a class="wordmark" :href="isEn ? page('en') : publicBase" :aria-label="isEn ? 'PentestCamp home' : 'PentestCamp, strona główna'" @click="close">
      <span class="wordmark-product">PentestCamp</span>
      <span class="wordmark-parent">by <img :src="`${publicBase}images/dsecure-logo-violet.png`" alt="DSecure.me" width="3506" height="512" /></span>
    </a>
    <button class="menu-toggle" type="button" :aria-expanded="open" aria-controls="site-navigation" :aria-label="menuLabel" @click="open = !open">
      <span /><span />
    </button>
    <nav id="site-navigation" class="site-nav" :class="{ 'is-open': open }" :aria-label="isEn ? 'Main navigation' : 'Główna nawigacja'">
      <a :href="isEn ? page('en/platform') : page('platforma')" @click="close">{{ isEn ? 'Platform' : 'Platforma' }}</a>
      <a :href="isEn ? page('en/how-it-works') : page('jak-dziala')" @click="close">{{ isEn ? 'How it works' : 'Jak działa' }}</a>
      <a :href="isEn ? page('en/reviews') : page('opinie')" @click="close">{{ isEn ? 'Reviews' : 'Opinie' }}</a>
      <a :href="isEn ? page('en/comparison') : page('porownanie')" @click="close">{{ isEn ? 'Comparison' : 'Porównanie' }}</a>
      <a :href="isEn ? page('en/deployment') : page('wdrozenie')" @click="close">{{ isEn ? 'Deployment' : 'Wdrożenie' }}</a>
      <a class="language-switch" :href="localePath" :lang="isEn ? 'pl' : 'en'" :hreflang="isEn ? 'pl' : 'en'" @click="close">{{ isEn ? 'PL' : 'EN' }}</a>
      <a class="nav-cta" :href="isEn ? page('en/contact') : page('contact')" @click="close">{{ isEn ? 'Let’s talk' : 'Porozmawiajmy' }}</a>
    </nav>
  </header>
</template>
